<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" align="center">
                <v-card
                    color="rgb(200, 200, 200, 1)"
                    :style="`border-bottom: 20px solid ${player.team.brandColor ? player.team.brandColor : 'teal'};`"
                    class=""
                >
                    <v-row class="pr-5 mx-0 py-2" justify="center" align="center">
                        <v-col cols="6" align="end">
                            <v-avatar style="border-radius: 10px;" size="100" color="white">
                                <img
                                    v-if="player.team.logo"
                                    width="100px"
                                    :src="`${assetsUrl}/${player.team.logo}`"
                                    contain
                                >
                                <v-icon v-else style="font-size: 80px;" class="teal--text"> mdi-basketball-hoop </v-icon>
                            </v-avatar>
                        </v-col>
                        <v-col cols="6" align="start">
                            <span :class="$vuetify.breakpoint.mobile ? 'text-h5' : 'text-h4'" style="font-family: Arial, sans-serif !important;">{{ player.team.name }}</span>
                        </v-col>
                        <v-col cols="6" class="py-0">
                            <img
                                :height="!$vuetify.breakpoint.mobile ? '300px' : '150px'"
                                :src="`${assetsUrl}/${player.image}`"
                                contain
                                @error="$event.target.src = defaultPlayerImg"
                            >
                        </v-col>
                        <v-col cols="6" class="px-0 mx-0" align="center">
                            <div style="background-color: rgb(200, 200, 200, 0.9);" class=" py-2 px-2">
                                <radar v-if="topStats" :player-data="getAverageStats()" :top-stats="topStats" :style="!$vuetify.breakpoint.mobile ? 'height: 200px !important; width: 300px !important;' : 'height: 120px !important; width: auto !important;'" />
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card
                    class="secondary-font"
                    color="#232323"
                    dark
                >
                    <v-row justify="center" align="center" class="mx-0 px-0">
                        <v-col cols="12" style="background-color: #232323;">
                            <match-type-choice @setType="setType" />
                        </v-col>
                    </v-row>
                    <v-row class="px-5">
                        <v-col cols="4" md="2" class="bottom-border" align="start">
                            <span class="text-h6">Όνομα</span>
                        </v-col>
                        <v-col cols="8" md="4" class="bottom-border" align="end">
                            <span class="text-subtitle-1"> {{ `${player.name}` }} </span>
                        </v-col>
                        <v-col cols="6" md="3" class="bottom-border" align="start">
                            <v-icon color="white">
                                mdi-pound
                            </v-icon>
                        </v-col>
                        <v-col cols="6" md="3" class="bottom-border" align="end">
                            <span class="text-subtitle-1"> {{ player.jersey }} </span>
                        </v-col>
                    </v-row>
                    <v-row class="px-5">
                        <v-col cols="6" md="3" class="bottom-border" align="start">
                            <span class="text-h6">Θέση</span>
                        </v-col>
                        <v-col cols="6" md="3" class="bottom-border" align="end">
                            <span class="text-subtitle-1"> {{ player.position }} </span>
                        </v-col>
                        <v-col cols="6" md="3" class="bottom-border" align="start">
                            <span class="text-h6">Ομάδα</span>
                        </v-col>
                        <v-col cols="6" md="3" class="bottom-border" align="end">
                            <span class="text-subtitle-1"> {{ player.team.name }} </span>
                        </v-col>
                    </v-row>
                    <v-row class="px-5">
                        <v-col cols="6" md="3" class="bottom-border" align="start">
                            <span class="text-h6"> Ύψος </span>
                        </v-col>
                        <v-col cols="6" md="3" class="bottom-border" align="end">
                            <span class="text-subtitle-1"> {{ player.height }} </span>
                        </v-col>
                        <v-col cols="6" md="3" class="bottom-border" align="start">
                            <span class="text-h6">Ημ. Γέννησης</span>
                        </v-col>
                        <v-col cols="6" md="3" class="bottom-border" align="end">
                            <span class="text-subtitle-1"> {{ player.birthday }} </span>
                        </v-col>
                    </v-row>
                    <v-row v-if="type !== 'cup'" class="px-5">
                        <!-- <v-col cols="6" md="3" class="text-h6" align="start">
                            <span class="text-h6"> Χαρτί Γιατρού </span>
                        </v-col>
                        <v-col cols="6" md="3" align="end">
                            <span class="text-subtitle-1">
                                <v-icon large :class="player.doctorCheck ? 'green--text' : 'red--text'">
                                    {{ player.doctorCheck ? 'mdi-check-outline' : 'mdi-close-circle-outline' }}
                                </v-icon>
                            </span>
                        </v-col> -->
                        <v-col cols="6" md="3" class="text-h6" align="start">
                            <span class="text-h6"> Αγώνες </span>
                        </v-col>
                        <v-col cols="6" md="3" align="end">
                            <span class="text-subtitle-1" :class="player.stats.filter(element => ((element.phase === 'regular_season') || (type === 'cup' && element.cup))).length < noOfMatches ? 'red--text' : 'green--text'"> {{ `${player.stats.filter(element => ((element.phase === 'regular_season') || (type === 'cup' && element.cup))).length} / ${noOfMatches}` }} </span>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card
                    elevation="0"
                    color="#232323"
                >
                    <v-row class="mx-0 px-0 my-0">
                        <v-col cols="12" class="mx-0 px-0">
                            <v-tabs
                                v-model="tab"
                                centered
                                class="rounded"
                                background-color="#232323"
                            >
                                <v-tabs-slider color="teal" />
                                <v-tab v-for="(item, index) in player.highlights ? items.concat('BIG Moments') : items" :key="index" style="font-size: 20px;">{{ item }}</v-tab>
                            </v-tabs>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <player-stats v-if="tab === 0" :total-stats="getCummulativeStats()" :avg-stats="getAverageStats()" />
        <v-row v-if="tab === 0 && player.stats.length > 0" justify="center" align="center">
            <v-col cols="12" class="mx-0 px-0" style="display: inline-flex; overflow-x: auto;" align="center">
                <span v-for="(stat, index) in player.stats" :key="`stat-${index}`">
                    <v-card v-if="stat.throwPositions" class="mx-1 px-2 py-2 " style="cursor: pointer;" color="#232323" dark @click="$router.push({ name: 'Match', params: { id: stat.matchId } })">
                        <v-card-title class="custom-teal-text justify-center my-0 pt-0" style="font-size: 20px; font-weight: bold;">
                            Shooting Chart vs
                            <v-avatar
                                size="50"
                                class="ml-2"
                                style="background-color: white; border-radius: 10px;"
                            >
                                <img :src="`${assetsUrl}/${stat.opponentTeamLogo}`" height="50px">
                            </v-avatar>
                        </v-card-title>
                        <v-card-subtitle class="text-subtitle-1">
                            <span class="" style="font-size: 15px;"> {{ stat.opponentTeamName }} </span>
                            <span class="" style="font-size: 15px; margin-left: 10px;"> ({{ new Date(stat.matchDatetime).toLocaleDateString('el-GR') }}) </span>
                            <div>
                                <span class="custom-teal-text" style="font-size: 15px; margin-left: 10px;"> 3P%: </span>
                                <span class="" style="font-size: 15px; margin-left: 10px;"> {{ `${((stat.threePointsMade / (stat.threePointAttempts || 1)) * 100).toFixed(0)}% (${stat.threePointsMade}/${stat.threePointAttempts})` }} </span>
                            </div>
                            <div>
                                <span class="custom-teal-text" style="font-size: 15px; margin-left: 10px;"> 2P%: </span>
                                <span class="" style="font-size: 15px; margin-left: 10px;"> {{ `${((stat.twoPointsMade / (stat.twoPointAttempts || 1)) * 100).toFixed(0)}% (${stat.twoPointsMade}/${stat.twoPointAttempts})` }} </span>
                            </div>
                        </v-card-subtitle>
                        <shooting-chart :shots="stat.throwPositions" />
                    </v-card>
                </span>
            </v-col>
        </v-row>
        <game-stats v-if="tab === 0" :stats="player.stats.filter(element => (type === 'cup' ? (type === 'cup' && element.cup) : (element.phase === type && !element.cup)))" />
        <player-records v-else-if="tab === 1" :stats="getMaxStats()" :team="player.team.name" />
        <player-moments v-else :moments="player.highlights" />
    </v-container>
</template>

<script>
    import PlayerStats from '@/components/PlayerStats'
    import ShootingChart from '@/components/ShootingChart'
    import PlayerMoments from '@/components/PlayerMoments'
    import GameStats from '@/components/GameStats'
    import PlayerRecords from '@/components/PlayerRecords'
    import playerService from '@/services/player'
    import configService from '@/services/config'
    import MatchTypeChoice from '@/components/MatchTypeChoice'
    import Radar from '@/components/Radar.vue'

    const gradients = [
        ['#ffd200'],
        ['#ffd200'],
        ['red', 'teal', 'yellow'],
        ['purple', 'violet'],
        ['#ffd200', '#F0F', '#FF0'],
        ['#f72047', '#ffd200', '#ffd200']
    ]

    export default {
        components: { PlayerStats, GameStats, PlayerRecords, PlayerMoments, MatchTypeChoice, Radar, ShootingChart },
        data() {
            return {
                player: {},
                items: ['Stats', 'Records'],
                tab: null,
                assetsUrl: 'https://storage.googleapis.com',
                showIcon: false,
                noOfMatches: 0,
                type: 'regular_season',
                matchTypes: ['regular_season', 'playoffs', 'cup'],
                sparkline: {
                    width: 2,
                    radius: 10,
                    padding: 8,
                    lineCap: 'round',
                    gradient: gradients[5],
                    gradientDirection: 'top',
                    gradients,
                    fill: false,
                    type: 'trend',
                    autoLineWidth: false
                },
                topStats: null,
                defaultPlayerImg: require('@/assets/default_player.png')
            }
        },
        watch: {
            '$route.params.id': {
                handler() {
                    this.getPlayer(this.$route.params.id)
                }
            },
            'player.noOfMatches': {
                handler() {
                    this.getNoOfMatches()
                },
                deep: true
            }
        },
        created() {
            this.getPlayer(this.$route.params.id)
            this.getTopStats()
        },
        methods: {
            getShootingChartData() {
                this.player.stats.filter(element => (element.phase === this.type || (this.type === 'cup' && element.cup))).forEach(element => {
                    if (element.throwPositions) {
                        element.throwPositions.forEach(shot => {
                            this.shots.push(shot)
                        })
                    }
                })
                return this.shots
            },
            setType(option) {
                this.type = this.matchTypes[option]
            },
            getPlayer(playerId) {
                playerService.getPlayer(playerId).then(resp => {
                    this.player = resp.data
                })
            },
            getTopStats() {
                playerService.getTopStats().then(resp => {
                    this.topStats = resp.data
                })
            },
            getCummulativeStats() {
                const stats = {
                    points: 0,
                    rebounds: 0,
                    assists: 0,
                    steals: 0,
                    turnovers: 0,
                    blockedShots: 0,
                    twoPointsMade: 0,
                    twoPointAttempts: 0,
                    threePointsMade: 0,
                    threePointAttempts: 0,
                    freeThrowsMade: 0,
                    freeThrowAttempts: 0,
                    offensiveRebounds: 0,
                    defensiveRebounds: 0,
                    personalFouls: 0,
                    pir: 0,
                    playTimeInSecs: 0
                }
                this.player.stats.filter(element => (element.phase === this.type || (this.type === 'cup' && element.cup))).forEach(element => {
                    for (const key of Object.keys(stats)) {
                        stats[key] += element[key]
                    }
                })
                return stats
            },
            getAverageStats() {
                const stats = {
                    points: 0,
                    rebounds: 0,
                    assists: 0,
                    steals: 0,
                    turnovers: 0,
                    blockedShots: 0,
                    twoPointsMade: 0,
                    twoPointAttempts: 0,
                    threePointsMade: 0,
                    threePointAttempts: 0,
                    freeThrowsMade: 0,
                    freeThrowAttempts: 0,
                    offensiveRebounds: 0,
                    defensiveRebounds: 0,
                    personalFouls: 0,
                    pir: 0,
                    playTimeInSecs: 0
                }
                this.player.stats.filter(element => (element.phase === this.type || (this.type === 'cup' && element.cup))).forEach(element => {
                    for (const key of Object.keys(stats)) {
                        stats[key] += element[key]
                    }
                })

                Object.keys(stats).forEach(element => {
                    if (this.player.stats.filter(element => (element.phase === this.type || (this.type === 'cup' && element.cup))).length) {
                        stats[element] = Math.round(stats[element] / this.player.stats.filter(element => (element.phase === this.type || (this.type === 'cup' && element.cup))).length * 10) / 10
                    } else {
                        stats[element] = 0
                    }
                })

                return stats
            },
            getMaxStats() {
                const stats = {
                    points: {
                        value: 0,
                        oponnent: null,
                        date: null,
                        text: 'points'
                    },
                    rebounds: {
                        value: 0,
                        oponnent: null,
                        date: null,
                        text: 'reb.'
                    },
                    assists: {
                        value: 0,
                        oponnent: null,
                        date: null,
                        text: 'assists'
                    },
                    steals: {
                        value: 0,
                        oponnent: null,
                        date: null,
                        text: 'steals'
                    },
                    turnovers: {
                        value: 0,
                        oponnent: null,
                        date: null,
                        text: 'turnov.'
                    },
                    blockedShots: {
                        value: 0,
                        oponnent: null,
                        date: null,
                        text: 'blocks'
                    },
                    twoPointsMade: {
                        value: 0,
                        oponnent: null,
                        date: null
                    },
                    threePointsMade: {
                        value: 0,
                        oponnent: null,
                        date: null
                    },
                    freeThrowsMade: {
                        value: 0,
                        oponnent: null,
                        date: null
                    }
                }
                this.player.stats.filter(element => (element.phase === this.type || (this.type === 'cup' && element.cup))).forEach(element => {
                    for (const key of Object.keys(stats)) {
                        if (element[key] >= stats[key].value) {
                            stats[key] = {
                                matchId: element.matchId,
                                value: element[key],
                                oponnent: element.opponentTeamName,
                                date: element.matchDatetime
                            }
                        }
                    }
                })

                return stats
            },
            getNoOfMatches() {
                configService.getConfigField(this.player.noOfMatches).then(resp => {
                    this.noOfMatches = resp.data[this.player.noOfMatches]
                })
            }
        }
    }
</script>

<style scoped>
.overlay {
    opacity: 0.3;
    filter: grayscale(1);
}

.text-subtitle-1 {
    font-size: 1.1rem !important;
    font-weight: 400;
    line-height: 1.75rem;
    letter-spacing: 0.009375em !important;
}

.text-h6 {
    font-size: 1.25rem !important;
    letter-spacing: 0.0125em !important;
    line-height: 2rem;
}

.v-tab {
    text-transform: none !important;
    font-weight: bolder;
    font-size: 15px;
    color: #757578 !important;
}

.v-tab::before {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    background-color: transparent;
}

.v-tab--active {
    color: teal !important;
}

.bottom-border {
    border-bottom: 0.01px solid rgb(231, 225, 225);
}
</style>
